import { render, staticRenderFns } from "./UsageComponent.vue?vue&type=template&id=3808989e&"
import script from "./UsageComponent.vue?vue&type=script&lang=js&"
export * from "./UsageComponent.vue?vue&type=script&lang=js&"
import style0 from "./UsageComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports